<template>
  <div class="homepage">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="brand">广东广福宏宇保险经纪有限公司</div>

        <!-- 桌面菜单 -->
        <ul class="desktop-menu" v-if="!isMobile">
          <li>
            <router-link
              to="/"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li>
            <router-link
              to="/product"
              :class="{ active: $route.name === 'product' }"
            >
              产品
            </router-link>
          </li>
        </ul>

        <!-- 移动端菜单按钮 -->
        <button
          class="mobile-menu-btn"
          v-if="isMobile"
          @click="showMobileMenu=!showMobileMenu"
        >☰</button>

        <!-- 移动端展开菜单 -->
        <ul class="mobile-menu" v-show="showMobileMenu">
          <li>
            <router-link
              to="/"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li>
            <router-link
              to="/product"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'product' }"
            >
              产品
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
    <!-- 主要内容区域 -->
    <main class="insure-main">
      <div class="container">
        <h2 class="page-title">保险投保申请</h2>

        <!-- 投保人信息 -->
        <div class="form-section applicant-info">
          <h3 class="section-title">投保人信息</h3>
          <div class="form-group">
            <label>投保人姓名：</label>
            <input type="text" placeholder="请输入投保人姓名">
          </div>
          <div class="form-group">
            <label>证件类型：</label>
            <select>
              <option>身份证</option>
            </select>
          </div>
          <div class="form-group">
            <label>证件号码：</label>
            <input type="text" placeholder="请输入证件号码">
          </div>
          <div class="form-group">
            <label>联系电话：</label>
            <input type="tel" placeholder="请输入手机号">
          </div>
        </div>

        <!-- 发票信息 -->
        <div class="form-section">
          <h3 class="section-title">发票信息</h3>
          <div class="form-group">
            <label>发票类型：</label>
            <div class="radio-group">
              <label>
                <input type="radio" value="电子发票" v-model="invoiceType"> 普通发票
              </label>
              <label>
                <input type="radio" value="纸质发票" v-model="invoiceType"> 电子专票
              </label>
            </div>
          </div>
        </div>

        <!-- 被保人信息 -->
        <div class="form-section">
          <h3 class="section-title">被保人信息</h3>
          <div class="insured-actions">
            <!-- 模板下载按钮 -->

            <!-- 新增：上传/下载按钮组 -->
            <div class="insured-actions">
              <!-- 原模板上传按钮 -->
              <button class="upload-btn" @click="handleTemplateUpload">模板上传</button>
              <!-- 新增模板下载按钮 -->
              <a
                href="/static/insured-template.xlsx"
                download="被保人信息模板.xlsx"
                class="download-btn"
              >
                模板下载
              </a>
              <button class="paste-btn" @click="showPasteModal = true">弹窗粘贴</button>
            </div>

          </div>

          <!-- 被保人列表 -->
          <div class="insured-list" v-if="insuredList.length">
            <table>
              <thead>
              <tr>
                <th>姓名</th>
                <th>证件号</th>
                <th>性别</th>
                <th>联系电话</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in insuredList" :key="index">
                <td>{{ item.name }}</td>
                <td>{{ item.idNumber }}</td>
                <td>{{ item.gender }}</td>
                <td>{{ item.phone }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <p v-else class="empty-tip">请通过模板上传或弹窗粘贴添加被保人信息</p>
        </div>

        <!-- 阅读文档区域 -->
        <div class="doc-section">
          <div class="doc-header">
            <input
              type="checkbox"
              id="check-all"
              v-model="checkAll"
            >
            <label for="check-all">我已阅读并同意以下所有文档</label>
          </div>
          <div class="doc-list">
            <div
              class="doc-item"
              v-for="doc in docList"
              :key="doc.id"
              @change="handleDocCheck"
            >
              {{ doc.name }}
            </div>
          </div>
        </div>
        <!-- 粘贴信息弹窗 -->
        <div class="modal" v-show="showPasteModal">
          <div class="modal-content">
            <h3>批量粘贴被保人信息</h3>
            <button class="close-btn" @click="showPasteModal = false">×</button>
            <!-- 修改提示文案 -->
            <p>请按以下格式粘贴（每行一条，用空格分隔字段，顺序不限）：</p>
            <p>示例：张三 440101199001011234 男 13800138000</p>
            <p>或：女 13900139000 李四 440101199102021235</p>
            <textarea
              v-model="pasteContent"
              placeholder="每行一条被保人信息，字段用空格分隔"
            ></textarea>
            <button class="confirm-btn" @click="handlePaste">确认添加</button>
          </div>
        </div>
      </div>
    </main>

    <!-- 文档内容弹窗 -->
    <div class="doc-modal" v-show="showDocModal">
      <div class="modal-content">
        <h3>{{ currentDocTitle }}</h3>
        <button class="close-btn" @click="showDocModal = false">×</button>
        <div class="doc-content">
          {{ currentDocContent }}
        </div>
      </div>
    </div>

    <!-- 底部固定导航栏 -->
    <div class="fixed-footer">
      <div class="container">
        <div class="footer-content">
          <span class="price">金额：¥{{ totalPrice }}</span>
          <button
            class="submit-btn"
            @click="handleSubmit"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? '投保中...' : '立即投保' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>© 2023 广东广福宏宇保险经纪有限公司 粤ICP备XXXXXXX号</p>
        <div class="footer-links">
          <a href="#about">关于我们</a>
          <a href="#contact">联系我们</a>
          <a href="#">隐私政策</a>
        </div>
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollToTop"
    >↑</button>
  </div>
</template>

<script>

export default {
  name: 'orderInsZFG',
  data () {
    return {
      isMobile: false, // 移动端判断
      showMobileMenu: false, // 移动端菜单显示状态
      showBackToTop: false, // 返回顶部按钮显示状态
      showDocModal: false, // 文档弹窗显示状态
      currentDocTitle: '', // 当前显示的文档标题
      currentDocContent: '', // 当前显示的文档内容
      // 投保人信息
      applicant: {
        name: '',
        idType: '身份证',
        idNumber: '',
        phone: ''
      },
      // 发票类型
      invoiceType: '电子发票',
      // 被保人列表
      insuredList: [],
      // 粘贴弹窗相关
      showPasteModal: false,
      pasteContent: '',
      docList: [ // 阅读文档列表
        { id: 1, name: '保险条款', content: '（文档内容...）' },
        { id: 2, name: '隐私政策', content: '（文档内容...）' },
        { id: 3, name: '免责声明', content: '（文档内容...）' }
      ],
      checkAll: false, // 全选状态
      checkedDocs: [], // 已勾选的文档ID
      currentDoc: null, // 当前显示的文档
      isSubmitting: false, // 提交中状态
      totalPrice: 1580, // 示例应付金额
      // 模拟文档数据
      docData: {
        '保险服务条款': '一、服务范围\n1.1 本保险服务覆盖家庭财产、机动车辆等常见保险类型，具体保障内容以保单约定为准。\n二、责任免除\n2.1 因投保人故意行为、战争、核辐射等不可抗力导致的损失，本公司不承担赔偿责任。',
        '隐私保护协议': '第一条 数据收集\n1.1 我们将收集投保人姓名、身份证号、联系方式等必要信息用于保单服务。\n第二条 数据使用\n2.1 仅用于保险服务相关流程，未经授权不会向第三方披露。',
        '免责声明': '一、责任免除\n1.1 被保险人未履行如实告知义务导致的损失，本公司不承担赔偿责任。\n二、争议解决\n2.1 本协议未尽事宜，双方可协商解决；协商不成的，提交有管辖权的人民法院诉讼解决。'
      }
    }
  },
  computed: {

  },
  mounted () {
    // 初始化移动端判断
    this.isMobile = window.innerWidth <= 768
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 模板上传处理（模拟）
    handleTemplateUpload () {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.csv,.xlsx'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (file) {
          // 实际应调用文件解析接口，这里模拟解析
          const mockData = [
            { name: '李四', idNumber: '440101199102021235', gender: '男', phone: '13900139000' },
            { name: '王五', idNumber: '440101199203031236', gender: '女', phone: '136000136000' }
          ]
          this.insuredList = [...this.insuredList, ...mockData]
        }
      }
      input.click()
    },
    // 粘贴信息处理
    // 修改粘贴信息处理逻辑
    handlePaste () {
      if (!this.pasteContent) return

      const newInsured = []
      const lines = this.pasteContent.split('\n')

      lines.forEach(line => {
        const fields = line.trim().split(/\s+/) // 按任意数量空格分割
        if (fields.length < 4) return // 至少需要4个字段

        const insured = { name: '', idNumber: '', gender: '', phone: '' }

        fields.forEach(field => {
          // 匹配身份证号（简单校验18位）
          if (/^\d{17}[\dXx]$/.test(field) && !insured.idNumber) {
            insured.idNumber = field
            // eslint-disable-next-line brace-style
          }
          // 匹配手机号（11位数字）
          else if (/^1[3-9]\d{9}$/.test(field) && !insured.phone) {
            insured.phone = field
            // eslint-disable-next-line brace-style
          }
          // 匹配性别
          else if (['男', '女'].includes(field) && !insured.gender) {
            insured.gender = field
            // eslint-disable-next-line brace-style
          }
          // 剩余字段作为姓名（取最后一个未匹配的字段）
          else if (!insured.name) {
            insured.name = field
          }
        })

        // 验证完整性
        if (insured.name && insured.idNumber && insured.gender && insured.phone) {
          newInsured.push(insured)
        }
      })

      this.insuredList = [...this.insuredList, ...newInsured]
      this.pasteContent = ''
      this.showPasteModal = false
    },
    // 切换文档显示
    toggleDoc (doc) {
      this.currentDoc = this.currentDoc.id === doc.id ? null : doc
    },

    // 新增：点击复选框触发文档查看
    handleDocCheck () {
      if (!this.checkAll) return // 取消勾选不触发
      this.showDocModal = true
      this.currentDocTitle = '保险服务条款' // 默认显示第一条
      this.currentDocContent = this.docData['保险服务条款']
    },

    // 立即投保处理
    handleSubmit () {
      // 验证是否勾选所有文档
      if (!this.checkAll) {
        // 未勾选时强制显示条款
        this.showDocModal = true
        this.currentDocTitle = '保险服务条款'
        this.currentDocContent = this.docData['保险服务条款']
        return
      }
      // 已勾选时提交逻辑（示例）
      alert('投保信息已提交，我们将尽快为您处理！')

      this.isSubmitting = true
      try {
        // 调用投保接口（示例）
        // this.$axios.post('/api/submit-insurance', {
        //   // 传递投保人/被保人信息...
        // })
        alert('投保成功！')
      } catch (error) {
        alert('投保失败，请重试')
      } finally {
        this.isSubmitting = false
      }
    },

    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },
    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },
    // 返回顶部
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>
<style scoped>
/* 阅读文档区域 */
.doc-section {
  margin-top: 25px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.doc-header {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.doc-list {
  display: flex;
  gap: 20px;
  overflow-x: auto; /* 横向滚动 */
  padding: 10px 0;
}

.doc-item {
  flex-shrink: 0; /* 防止内容被压缩 */
  white-space: nowrap; /* 文字不换行 */
}

.doc-item input {
  margin-right: 5px;
}

/* 半弹窗 */
.doc-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  padding: 20px;
  border-radius: 8px;
  overflow-y: auto;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}

.doc-content {
  margin-top: 25px;
  line-height: 1.8;
  font-size: 0.95rem;
}

/* 底部固定导航栏 */
.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
  padding: 15px 0;
  z-index: 999;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price {
  color: #e74c3c;
  font-size: 1.1rem;
  font-weight: bold;
}

.submit-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 新增/修改样式 */
.insure-main {
  margin-top: 80px; /* 导航栏高度 */
  padding: 20px 0 100px; /* 底部预留固定导航栏空间 */
}

.form-section {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 30px;
}

.section-title {
  font-size: 1.4rem;
  color: #3498db;
  margin-bottom: 20px;
}

.form-group {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 15px;
  margin-bottom: 15px;
  align-items: center;
}

.form-group input, .form-group select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 8px;
}
/* 新增上传表单样式 */
.insure-main {
  margin-top: 100px; /* 导航栏高度 */
  padding: 30px 0;
}

.insured-actions {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap; /* 小屏幕换行 */
}

.upload-btn, .download-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: opacity 0.3s;
}

.upload-btn {
  background: #2ecc71; /* 上传按钮绿色 */
  color: white;
}

.download-btn {
  background: #3498db; /* 下载按钮蓝色 */
  color: white;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.upload-btn:hover, .download-btn:hover {
  opacity: 0.9;
}

/* 模板下载按钮 */
.template-download {
  margin-bottom: 30px;
  text-align: center;
}

.download-btn {
  display: inline-block;
  background: #2ecc71;
  color: white;
  padding: 12px 25px;
  border-radius: 6px;
  text-decoration: none;
  font-size: 1rem;
  transition: background 0.3s;
}

.download-btn:hover {
  background: #27ae60;
}

/* 移动端适配（屏幕宽度≤768px） */
@media (max-width: 768px) {
  .doc-list {
    gap: 15px;
    padding: 10px 5px;
  }

  .doc-item {
    font-size: 0.9rem;
  }

  .fixed-footer .container {
    padding: 0 10px;
  }

  .price {
    font-size: 1rem;
  }

  .submit-btn {
    padding: 8px 20px;
    font-size: 0.95rem;
  }

  .form-section {
    padding: 15px; /* 缩小表单内边距 */
  }

  .section-title {
    font-size: 1.2rem; /* 缩小标题字体 */
  }

  .form-group {
    grid-template-columns: 1fr; /* 小屏幕下标签和输入框垂直排列 */
    gap: 8px;
  }

  .form-group label {
    font-size: 0.9rem; /* 缩小标签字体 */
  }

  .form-group input, .form-group select {
    padding: 6px; /* 缩小输入框内边距 */
    font-size: 0.9rem; /* 缩小输入框字体 */
  }

  .radio-group {
    flex-direction: column; /* 小屏幕下单选按钮垂直排列 */
    gap: 12px;
  }
}
@media (max-width: 768px) {
  .insured-actions {
    flex-direction: column; /* 小屏幕垂直排列 */
    gap: 10px;
  }
  .upload-btn, .download-btn {
    width: 100%; /* 按钮占满宽度 */
    justify-content: center;
  }
}
.insure-main {
  margin-top: 100px; /* 导航栏高度 */
  padding: 20px 0;
}
@media (max-width: 768px) {
  .insure-main .container {
    padding: 0 10px; /* 缩小容器内边距 */
  }

  .form-group {
    grid-template-columns: 1fr; /* 表单标签和输入框垂直排列 */
    gap: 8px;
  }

  .form-group label {
    font-size: 0.9rem;
  }

  .insured-list table {
    min-width: 600px; /* 表格最小宽度，配合横向滚动 */
  }

  .insured-list {
    overflow-x: auto; /* 小屏幕表格横向滚动 */
  }

  .modal-content {
    width: 95%; /* 弹窗宽度占满屏幕 */
    padding: 20px;
  }
}
.insure-main {
  margin-top: 100px;
  padding: 30px 0;
}

.page-title {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 30px;
}

.form-section {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 30px;
}

.section-title {
  font-size: 1.4rem;
  color: #3498db;
  margin-bottom: 20px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.insured-actions {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.upload-btn, .paste-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.upload-btn {
  background: #2ecc71;
  color: white;
}

.paste-btn {
  background: #3498db;
  color: white;
}

.insured-list table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

.insured-list th, .insured-list td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.insured-list th {
  background: #3498db;
  color: white;
}

.empty-tip {
  color: #999;
  text-align: center;
  padding: 20px;
}

/* 弹窗样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal textarea {
  width: 100%;
  height: 150px;
  padding: 10px;
  margin: 15px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.confirm-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}
/* 新增/修改样式 */
.homepage {
  display: flex;          /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh;      /* 至少占满整个视口高度 */
}

.product-main {
  flex: 1;                /* 内容区域自动扩展占据剩余空间 */
}
/* 页脚 */
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0;
  text-align: center;
  margin-top: auto;       /* 页脚自动靠底部 */
}

.footer-links {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #3498db;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}
/* 基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 移动端适配 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}
/* 新增样式 */
/* 导航栏选中状态 */
.desktop-menu .active a,
.mobile-menu .active a {
  color: #3498db;
  font-weight: bold;
  position: relative;
}

.desktop-menu .active a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #3498db;
}

/* 产品分类列表 */
.product-categories {
  margin: 120px 0 40px;
}

.category-list {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.category-list button {
  padding: 8px 20px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.category-list button:hover,
.category-list button.active {
  background: #3498db;
  color: white;
  border-color: #3498db;
}

/* 产品列表 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.product-card {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  transition: transform 0.3s;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 15px;
}

.price {
  color: #e74c3c;
  font-size: 1.2rem;
  margin: 10px 0;
}
/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.desktop-menu {
  display: flex;
  gap: 30px;
}

.desktop-menu li a, .mobile-menu li a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.desktop-menu li a:hover {
  color: #3498db;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/insure/orderInsZFG.vue